var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2105 16.6667V17.4444C19.2105 18.3 18.5 19 17.6316 19H6.57895C5.70263 19 5 18.3 5 17.4444V6.55556C5 5.7 5.70263 5 6.57895 5H17.6316C18.5 5 19.2105 5.7 19.2105 6.55556V7.33333H12.1053C11.2289 7.33333 10.5263 8.03333 10.5263 8.88889V15.1111C10.5263 15.9667 11.2289 16.6667 12.1053 16.6667H19.2105ZM12.1053 14.1111C12.1053 14.6634 12.553 15.1111 13.1053 15.1111H18C19.1046 15.1111 20 14.2157 20 13.1111V10.8889C20 9.78432 19.1046 8.88889 18 8.88889H13.1053C12.553 8.88889 12.1053 9.3366 12.1053 9.88889V14.1111ZM15.2632 13.1667C14.6079 13.1667 14.0789 12.6456 14.0789 12C14.0789 11.3544 14.6079 10.8333 15.2632 10.8333C15.9184 10.8333 16.4474 11.3544 16.4474 12C16.4474 12.6456 15.9184 13.1667 15.2632 13.1667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a22d0cce573d690f9e1bcf0dbdc3e834.svg";
export { ForwardRef as ReactComponent };